import { t } from '@/plugins/i18n'

export const fields = [
  {
    name: 'sku',
    name_zh: 'sku',
    key: 'sku_small',
    type: 'barcode',
    title: 'sku',
    testData: 'vl-1111-wh-f',
    height: 40,
    hideTitle: true,
    width: 80
  },
  {
    name: 'Sku',
    name_zh: 'Sku',
    key: 'sku_large',
    testData: '122511111-BLU-FREE-SEECLB111',
    hideTitle: true,
    fontSize: '5.4'
  },
  {
    name: t('商品名'),
    name_zh: '商品名',
    key: 'productName',
    hideTitle: true,
    title: '商品名',
    testData: 'デニムカバーオール',
    fontSize: '6',
    letterSpacing: '0'
  },
  // {
  //   name: 'Name',
  //   name_zh: 'Name',
  //   hideTitle: true,
  //   key: 'name',
  //   testData: 'name'
  // },
  {
    name: 'SIZE',
    name_zh: 'SIZE',
    hideTitle: true,
    key: 'size',
    testData: 'XL'
  },
  {
    name: 'NO',
    name_zh: 'NO',
    hideTitle: true,
    key: 'no',
    testData: '122511111'
  },
  {
    name: 'COL',
    name_zh: 'COL',
    hideTitle: true,
    key: 'col',
    testData: 'BLK'
  },
  {
    name: 'Brand',
    name_zh: 'Brand',
    hideTitle: true,
    key: 'brand',
    testData: 'THECKB'
  },
  {
    name: t('条形码'),
    name_zh: '条形码',
    hideTitle: true,
    testData: t('条形码'),
    key: 'UPC',
    hideInSelect: true
  },
  {
    name: t('客户码'),
    name_zh: '客户码',
    hideTitle: true,
    key: 'customerCode',
    testData: '231212'
  },
  {
    name: 'Price',
    name_zh: 'Price',
    hideTitle: true,
    key: 'price',
    testData: '4,400'
  },
  {
    name: t('メーカー品番'),
    name_zh: 'メーカー品番',
    hideTitle: true,
    key: 'productCode',
    testData: t('メーカー品番')
  }
]

interface optionsFormatProp {
  templateType: string,
  templateData?: string,
  templateName?: string
}
export const optionsFormat = (props: optionsFormatProp) => {
  let option = {} as any
  switch (props.templateType) {
    case 'text2': option = {
      textType: 'text',
      title: props.templateData,
      width: 60,
      height: 12
    }
      break
    case 'logo': option = {
      textType: 'text',
      title: 'LOGO',
      name: t('LOGO'),
      name_zh: 'LOGO',
      width: 50,
      height: 30
    }
      break
    case 'line': option = {
      textType: 'hline',
      title: 'hline',
      height: 10,
      width: 80,
      borderWidth: 0.75
    }
      break
    case 'barcode': option = {
      ...fields.filter(v => v.key === 'UPC')[0],
      textType: props.templateType,
      field: fields.filter(v => v.key === 'UPC')[0].key,
      title: fields.filter(v => v.key === 'UPC')[0].name,
      hideTitle: false,
      testData: '124040800005',
      textAlign: 'center',
      transform: '0',
      height: 20,
      width: 60
    }
      break
    default: option = {
      ...fields.filter(v => v.key === props.templateName)[0],
      textType: props.templateType,
      field: fields.filter(v => v.key === props.templateName)[0].key,
      title: fields.filter(v => v.key === props.templateName)[0].name,
      height: 12,
      width: 60
    }
      break
  }
  return option
}
